'use strict'

import Isotope from 'isotope-layout';

const zoom =  {
    init: function() {
        zoom.layout();
        zoom.slider();
    },
    layout: function() {
        let grid = document.querySelector('.zoom_list');
        // init Isotope
        if ( grid ) {
            const iso = new Isotope(grid, {
                itemSelector: '.zoom_item',
                layoutMode: 'masonry',
                stagger: 30,
                horizontalOrder: true,
                percentPosition: true,
                masonry: {
                  columnWidth: '.grid_sizer'
                }
            });
            grid.style.opacity = 1;
            return iso;
        }
    },

    // mise en place d'un slider maison sur le bloc ZOOM seulement sur mobile
    slider: function() {
        let sliding = 0;
        if( document.querySelector('.zoom_nav') ) {
            let prev = document.querySelector('.zoom_nav-prev'),
                next = document.querySelector('.zoom_nav-next'),
                wrapper = document.querySelector('.zoom_list'),
                sizer = document.querySelector('.grid_sizer');

            prev.addEventListener('click', function() {
                slideToPrev();
            });
            
            next.addEventListener('click', function() {
                slideToNext();
            });

            // listen touch on mobile and tablet
            let ts;
            wrapper.addEventListener("touchstart", function(e) {
                ts = e.touches[0].clientX;
            });
            wrapper.addEventListener("touchend", function(e) {
                let te = e.changedTouches[0].clientX;
                if(window.matchMedia("(max-width: 1023px)").matches) {
                    if (ts > te) {
                        slideToNext();
                    } else if (ts < te) {
                        slideToPrev();
                    }
                }
            });

            function slideToPrev() {
                if( prev.classList.contains('disabled'))
                    return false;
                else {
                    sliding = sliding + sizer.offsetWidth;
                    if(sliding >= 0) {
                        sliding = 0;
                        wrapper.style.transform = "translate(0, 0)";
                        prev.classList.add('disabled');
                        next.classList.remove('disabled');
                    } else {
                        wrapper.style.transform = "translate(" + sliding + "px, 0)";
                        prev.classList.remove('disabled');
                        next.classList.remove('disabled');
                    }
                }
            }
            function slideToNext() {
                if( next.classList.contains('disabled'))
                    return false;
                else {
                    sliding = sliding - sizer.offsetWidth;
                    if(sliding <= (-wrapper.offsetWidth + sizer.offsetWidth)) {
                        wrapper.style.transform = "translate(" + -wrapper.offsetWidth - sizer.offsetWidth + "px, 0)";
                        next.classList.add('disabled');
                        prev.classList.remove('disabled');
                    } else {
                        wrapper.style.transform = "translate(" + sliding + "px, 0)";
                        if (sliding <= (-wrapper.offsetWidth + sizer.offsetWidth + 85)) {
                            next.classList.add('disabled');
                            prev.classList.remove('disabled');
                        } else {
                            next.classList.remove('disabled');
                            prev.classList.remove('disabled');
                        }
                    }
                }
            }
        }
    },
}


export default zoom;


// WEBPACK FOOTER //
// ./src/scripts/components/zoom.js